import React, { Suspense } from 'react';
import PageTransition from '../motion/pageTransition';
import LoadingSpinner from './LoadingSpinner/LoadingSpinner';

export class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-container">
          <h2>Siden kunne ikke vises</h2>
          <p>Noget gik galt under indlæsningen. Prøv igen, eller gå til en anden side.</p>
          <button type="button" className="retry-button" onClick={() => this.setState({ error: null })}>
            Prøv igen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export function RouteWithTransition({ children }) {
  return (
    <PageTransition>
      <Suspense fallback={<LoadingSpinner message="Indlæser siden..." size="medium" fill />}>
        {children}
      </Suspense>
    </PageTransition>
  );
}

export default RouteWithTransition;
